module.exports = __webpack_public_path__ + "static/media/shrink.ae114196.svg";